import { Component, inject, TemplateRef, ViewChild } from '@angular/core';
import { Config } from 'datatables.net';
import { ApiServiceListService } from 'src/app/_services/api/api-service-list.service';
import { offerSelectionType, offerType, pageList, typeList, unitList } from 'src/assets/config/constants';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { map, Subscription } from 'rxjs';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/_services/common/common.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { LocalizedString } from 'src/app/model/localized-string.model';


@Component({
    selector: 'app-add-offer',
    templateUrl: './add-offer.component.html',
    styleUrl: './add-offer.component.css',
    standalone: false
})
export class AddOfferComponent {
  
  private loader = inject(LoadingBarService);
  private loadingBarRef = this.loader.useRef();
  showLoader: boolean = false;
  public breadcrumb: any;
  options = {
    close: false,
    expand: false,
    minimize: false,
    reload: false
  };

  tagsList: any = [];
  productList: any = [];
  stateList: any = [];
  cityList: any = [];
  eventList: any = [];
  templeList: any = [];
  templeEventList: any = [];

  closeResult = '';
  dropdownSettings: any = {};
  dropdownSettingsMulti: any = {
    singleSelection: false,
    idField: '_id',
    textField: 'name',
    // selectAllText: 'Select All',
    // unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    enableCheckAll:false,
    allowSearchFilter: true,
    maxHeight:120,
  };
  // page literals
  model: any = {
    title: { en: '', te: '' },
    headerImage: '',
    backgroundImage: '',
    status: true,
    type: '',
    offerType: '',
    state: '',
    city: '',
    page: [],
    selectedPage: [],
    offers: [
      {
        image: "",
        offerType: '',
        selectedTags: [],
        tags: [],
        product: '',

      }
    ],

  };
  offerSelectionType: any = offerSelectionType;
  pageList: any = pageList;
  typeList: any = offerType;
  offerTypeList = [
    { _id: '', name: 'Product / Prasadam' },
    { _id: 'event', name: 'Event' },
    { _id: 'temple', name: 'Temple' },
    { _id: 'templeevent', name: 'Temple Event' },
  ];


  selectProduct: any = {};
  mainCategoryList: any = [];
  categoryList: any = [];
  subCategoryList: any = [];
  selectedIndex: any = 0;
  isEditPage: boolean = false;
  private routeSub: Subscription;
  deleteOfferList:string[] = []; 


  @ViewChild('prodModal') prodModal: TemplateRef<any>; // Note: TemplateRef



  constructor(private router: Router, private route: ActivatedRoute, private apiService: ApiServiceListService, private http: HttpClient, private modalService: NgbModal,
    private toastr: ToastrService, protected cmnService: CommonService) {
    this.routeSub = this.route.params.subscribe(params => {
      // console.log(params) //log the entire params object
      // console.log(params['id']) //log the value of id
      if (params != undefined && params['id'] != undefined) {
        this.isEditPage = true
        this.getItemById(params['id']);
      } else {
        this.isEditPage = false;
      }
    });

    this.breadcrumb = {
      'mainlabel': 'Offer Management',
      'links': [
        {
          'name': this.isEditPage ? 'Edit Offer' : 'Add Offer',
          'isLink': false,
          'link': '#'
        },
      ]
    };


    this.dropdownSettings = {
      singleSelection: true,
      idField: '_id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };

    this.getTagsList();
    this.getStatesList();
  }



  getItemById(id) {
    let parameter: any = {
      methodType: "GET",
    }
    this.loadingBarRef.increment(35);
    this.apiService.getOfferByGroupAPI(parameter, id).subscribe(
      {
        next: (response: any) => {
          if (response.success) {
            this.model = { ...response.data[0] };
            this.model.title = this.normalizeLocalizedString(this.model.title);
            this.model.offerType = this.model.offerType || '';
            this.model.state = this.model?.state || '';
            this.model.city = this.model?.city || '';
            this.model.headerImage = this.model.headerImage === 'NA' ? '' : (this.model.headerImage || '');
            this.model.backgroundImage = this.model.backgroundImage === 'NA' ? '' : (this.model.backgroundImage || '');
            this.getTagsList();
            if (this.model.state) {
              this.getCitiesList(this.model.state);
            }
            if (this.model.city) {
              this.loadOfferTargets();
            }
            // let tempPage = this.changeToMulti(response.data[0].page);
            // this.model.selectedPage =  tempPage;
            for (let i = 0; i < response.data[0].offers.length; i++) {
              const element = response.data[0].offers[i];
              if (element.tags.length > 0) {
                element.offerType = 'Tags';
                element.selectedTags = this.changeToMulti(element.tags);
              } else if (element.event) {
                element.offerType = 'Event';
                element.selectedEvent = [{ _id: element.event, name: element.event }];
              } else if (element.temple) {
                element.offerType = 'Temple';
                element.selectedTemple = [{ _id: element.temple, name: element.temple }];
              } else if (element.templeEvent) {
                element.offerType = 'TempleEvent';
                element.selectedTempleEvent = [{ _id: element.templeEvent, name: element.templeEvent }];
              } else if (element.product) {
                element.offerType = 'Product';
                element.productName = element.product.name;
                this.getMainCategory();
              }else{
                element.offerType = '';
              }
              this.deleteOfferList = [];
            }

            this.model.status = this.cmnService.getStatusRetrunValue(response.data[0].status);
          }
          this.loadingBarRef.complete();
        },
        error: (err) => {
          console.log(err);
          this.loadingBarRef.complete();
        }
      }
    );
    // tempModel.page = this.changeToMulti(tempModel.page);

  }

  changeToMulti(arr: []) {
    let tempMulti = [];
    for (let i = 0; i < arr.length; i++) {
      const element = arr[i];
      tempMulti.push({ _id: element, name: element });
    }
    return tempMulti;

  }
  addNewImage() {
    this.model.offers.push({
      image: "",
      offerType: '',
      tags: [],
      product: ''
    });
  }

  removeImage(index: number) {
    this.model.offers.splice(index, 1);
  }

  getTagsList() {
    this.apiService.getTagsList({ type: this.model.offerType || '' }).subscribe(
      {
        next: (response: any) => {
          let tempTags = [];
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            tempTags.push({ _id: element.name, name: element.name })
          }
          this.tagsList = tempTags;
        },
        error: (err) => {
          console.log(err);

        }
      }
    );
  }

  // selection of category type
  offerSelectionChange(sel: string, i) {
    // console.log(sel, i);

    if (sel === 'Product') {
      this.selectedIndex = i;
      // document.getElementById("openModalButton").click();
      this.model.offers[this.selectedIndex].tags = [];
      this.model.offers[this.selectedIndex].selectedTags = [];
      this.clearSingleTargets(this.selectedIndex);

      this.getMainCategory();
      this.modalService.open(this.prodModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
        if (result == 'Save Click') {
          // self.saveTag();
        } else {
          this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
        }
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });;

    } else if (sel === 'Tags') {
      this.selectedIndex = i;
      this.model.offers[this.selectedIndex].product = '';
      this.model.offers[this.selectedIndex].productName = '';
      this.clearSingleTargets(this.selectedIndex);
     
    } else{
      this.selectedIndex = i;
      this.model.offers[this.selectedIndex].product = '';
      this.model.offers[this.selectedIndex].productName = '';
      this.model.offers[this.selectedIndex].tags = [];
      this.model.offers[this.selectedIndex].selectedTags = [];
      this.clearSingleTargets(this.selectedIndex);
    }
  }

  openModal(OpenShowModelContent, item: any, index: number) {
    let self = this;
    this.selectedIndex = index;
    console.log(this.selectedIndex);
    console.log(item);


    self.modalService.open(OpenShowModelContent, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'lg', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Save Click') {

      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  setProduct(valid) {
    if (valid) {
      this.model.offers[this.selectedIndex].product = this.selectProduct.selectedProduct[0]._id;
      this.model.offers[this.selectedIndex].productName = this.selectProduct.selectedProduct[0].name;
      this.modalService.dismissAll();
    }
  }

  private getDismissReason(reason: any): string {
    // console.log(reason);

    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getMainCategory() {
    let parameter: any = {
      methodType: "GET",
    }
    this.apiService.getMainCategoryList(parameter).subscribe({
      next: (response: any) => {
        this.mainCategoryList = response.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        console.log("Comple");

      }
    });
  }
  updateDrpdown(type: string) {
    if (type == 'main') {
      this.getCategory();
      this.selectProduct.category = undefined;
      this.selectProduct.subCategory = undefined;
      this.selectProduct.selectedProduct = undefined;


    } else if (type == 'cate') {
      this.getSubCategory();
      this.selectProduct.subCategory = undefined;
      this.selectProduct.selectedProduct = undefined;
    } else if (type == 'sub') {
      this.getProductList();
      this.selectProduct.selectedProduct = undefined;
    }
  }


  getCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};

    body.mainCategory = this.selectProduct.mainCategory[0];
    this.apiService.getCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.categoryList = response.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  getSubCategory() {
    let parameter: any = {
      methodType: "POST",
    }
    let body: any = {};
    body.category = this.selectProduct.category[0];
    this.apiService.getSubCategoryList(parameter, body).subscribe({
      next: (response: any) => {
        this.subCategoryList = response.data;
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {

      }
    });
  }

  getProductList() {
    let parameter: any = {
      methodType: "GET",
    }

    this.apiService.getAdminProductBySubCategory({ subCategory: this.selectProduct.subCategory[0]._id }).subscribe(
      {
        next: (response: any) => {
          let tempProducts = [];
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            tempProducts.push({ _id: element._id, name: element.name })
          }
          this.productList = tempProducts;
        },
        error: (err) => {
          console.log(err);

        }
      }
    );
  }


  addOffer(valid) {
    if (valid) {


      let body: any = {};

      body = { ...this.model };
      body.title = this.normalizeLocalizedString(this.model.title);
      body.offerType = this.model.offerType || '';
      body.state = this.model.state || '';
      body.city = this.model.city || '';
      body.headerImage = String(this.model.headerImage || '').trim() || 'NA';
      body.backgroundImage = String(this.model.backgroundImage || '').trim() || 'NA';

      if(this.model.offers.length === 0){
        this.toastr.error("Please select atleast one offer", '', {
          timeOut: 3000,
        });
        return;
      }

      // For showing 6 images in user app. need to accept 6 offer list
      if(this.model.type === 'grid' && this.model.offers.length !== 6){
        this.toastr.error("Please select 6 offers for grid view", '', {
          timeOut: 3000,
        });
        return;
      }

      for (let i = 0; i < this.model.offers.length; i++) {
        const element = this.model.offers[i];
        if (element.offerType == 'Tags') {
          let tempArr = []
          for (let j = 0; j < element.selectedTags?.length; j++) {
            const element2 = element.selectedTags[j];
            tempArr.push(element2.name);
          }
          body.offers[i].tags = tempArr;
        }
        if (element.offerType == 'Event') {
          body.offers[i].event = element.selectedEvent?.[0]?._id || element.event || '';
        }
        if (element.offerType == 'Temple') {
          body.offers[i].temple = element.selectedTemple?.[0]?._id || element.temple || '';
        }
        if (element.offerType == 'TempleEvent') {
          body.offers[i].templeEvent = element.selectedTempleEvent?.[0]?._id || element.templeEvent || '';
        }

      }

      body.status = this.cmnService.getStatusValue(this.model.status);


      // body.page = [];

      // for (let i = 0; i < this.model.selectedPage.length; i++) {
      //   const element = this.model.selectedPage[i];
      //   body.page.push(element.name);
      // }
      this.showLoader = true;
      if (this.isEditPage) {
        delete body._id;
        let parameter: any = {
          methodType: "PUT",
        }
        body.offersDeleted = [...new Set(this.deleteOfferList)];
        this.apiService.updateOfferAPI(parameter, body).subscribe((response: any) => {
          if (response.success) {
            this.toastr.success(response.message, '', {
              timeOut: 3000,
            });
            this.router.navigateByUrl('/offer/all');
          } else {
            this.toastr.error(response.message, '', {
              timeOut: 3000,
            });
          }
          this.showLoader = false;

        }, (error) => {
          this.showLoader = false;
        });
      } else {
        let parameter: any = {
          methodType: "POST",
        }
        this.apiService.addOfferAPI(parameter, body).subscribe((response: any) => {
          console.log(response);
          if (response.success) {
            if (response.success) {
              this.toastr.success(response.message, '', {
                timeOut: 3000,
              });
            } else {
              this.toastr.error(response.message, '', {
                timeOut: 3000,
              });
            }
            this.router.navigateByUrl('/offer/all');

          }
          this.showLoader = false;

        }, (error) => {
          this.showLoader = false;

        });
        // }
      }
    }
  }

  navigateTOList() {
    this.router.navigateByUrl('/offer/all');
  }

  deleteOfferCheck(deleteModal: any, item, index) {
    let self = this;
    console.log(item);

    self.modalService.open(deleteModal, { ariaLabelledBy: 'modal-basic-title', keyboard: false, backdrop: 'static', size: 'sm', centered: true }).result.then((result) => {
      console.log("self.selectObj", result);
      if (result == 'Ok click') {
        this.deleteOfferList.push(item);
        this.model.offers.splice(index, 1);
        // this.deleteOffer(item, i);
      } else {
        this.closeResult = `Dismissed ${this.getDismissReason(result)}`;
      }


    }, (reason) => {
      console.log("close");

      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  deleteOffer(id, i) {
    // let parameter: any = {
    //   methodType: "DELETE",
    // }
    // let body: any = {};
    // body = { _id: id }

    this.deleteOfferList.push(id);
    return;
    // this.apiService.deleteOfferAPI(body).subscribe((response: any) => {
    //   console.log(response);
    //   if (response.success) {
    //     if (response.success) {
    //       this.toastr.success(response.message, '', {
    //         timeOut: 3000,
    //       });
    //     } else {
    //       this.toastr.error(response.message, '', {
    //         timeOut: 3000,
    //       });
    //     }
    //     this.getItemById(this.model._id);
    //   }
    // }, (error) => {

    // });
  }

  onTopOfferTypeChange() {
    this.model.state = '';
    this.model.city = '';
    this.cityList = [];
    this.eventList = [];
    this.templeList = [];
    this.templeEventList = [];
    this.model.offers = (this.model.offers || []).map((item: any) => ({
      image: item.image || '',
      offerType: '',
      selectedTags: [],
      tags: [],
      product: '',
      productName: '',
    }));
    this.getTagsList();
  }

  getStatesList() {
    this.apiService.getStatesList().subscribe({
      next: (response: any) => {
        this.stateList = response?.data || [];
      },
      error: (err) => console.log(err)
    });
  }

  getCitiesList(stateId: string = '') {
    if (!stateId) {
      this.cityList = [];
      return;
    }
    this.apiService.getCitiesList(stateId).subscribe({
      next: (response: any) => {
        this.cityList = response?.data || [];
      },
      error: (err) => console.log(err)
    });
  }

  onStateChange() {
    this.model.city = '';
    this.getCitiesList(this.model.state || '');
  }

  onCityChange() {
    this.loadOfferTargets();
  }

  loadOfferTargets() {
    if (!this.model.city) return;
    if (this.model.offerType === 'event') {
      this.apiService.getDevotionalEventTableData({ body: { pageSize: 100, currentPage: 1, city: this.model.city } }).subscribe({
        next: (response: any) => {
          this.eventList = (response?.data?.tableData || []).map((item: any) => ({ _id: item._id, name: item.title || item.eventId || '' }));
          this.hydrateSelectedTargetNames('Event', this.eventList, 'selectedEvent', 'event');
        },
        error: (err) => console.log(err)
      });
    }
    if (this.model.offerType === 'temple') {
      this.apiService.getTempleTableData({ body: { pageSize: 100, currentPage: 1, city: this.model.city } }).subscribe({
        next: (response: any) => {
          this.templeList = (response?.data?.tableData || []).map((item: any) => ({ _id: item._id, name: item.name || item.templeId || '' }));
          this.hydrateSelectedTargetNames('Temple', this.templeList, 'selectedTemple', 'temple');
        },
        error: (err) => console.log(err)
      });
    }
    if (this.model.offerType === 'templeevent') {
      this.apiService.getTempleEventTableData({ body: { pageSize: 100, currentPage: 1, city: this.model.city } }).subscribe({
        next: (response: any) => {
          this.templeEventList = (response?.data?.tableData || []).map((item: any) => ({ _id: item._id, name: item.title || item.templeEventId || '' }));
          this.hydrateSelectedTargetNames('TempleEvent', this.templeEventList, 'selectedTempleEvent', 'templeEvent');
        },
        error: (err) => console.log(err)
      });
    }
  }

  getBottomOfferTypeOptions() {
    if (!this.model.offerType) return [{ name: 'Tags' }, { name: 'Product' }];
    if (this.model.offerType === 'event') return [{ name: 'Tags' }, { name: 'Event' }];
    if (this.model.offerType === 'temple') return [{ name: 'Tags' }, { name: 'Temple' }];
    if (this.model.offerType === 'templeevent') return [{ name: 'Tags' }, { name: 'TempleEvent' }];
    return [{ name: 'Tags' }];
  }

  isCityOfferType() {
    return ['event', 'temple', 'templeevent'].includes(this.model.offerType || '');
  }

  private clearSingleTargets(index: number) {
    const item = this.model.offers[index];
    if (!item) return;
    item.event = '';
    item.temple = '';
    item.templeEvent = '';
    item.selectedEvent = [];
    item.selectedTemple = [];
    item.selectedTempleEvent = [];
  }

  private hydrateSelectedTargetNames(offerType: string, list: any[], selectedKey: string, valueKey: string) {
    (this.model.offers || []).forEach((item: any) => {
      if (item.offerType !== offerType || !item[valueKey]) return;
      const match = list.find((row: any) => String(row._id) === String(item[valueKey]));
      item[selectedKey] = match ? [match] : [{ _id: item[valueKey], name: item[valueKey] }];
    });
  }

  private normalizeLocalizedString(value: any): LocalizedString {
    if (!value) {
      return { en: '', te: '' };
    }
    if (typeof value === 'string') {
      return { en: value, te: '' };
    }
    return {
      en: value.en || '',
      te: value.te || '',
    };
  }
}

